module.exports = __webpack_public_path__ + "img/2022_L.bdbee449.png";